// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingScreen_container__1U5xJ","icons":"LoadingScreen_icons__1lcO4"};